module.exports = __webpack_public_path__ + "static/media/aditya_deshmukh.1d5f0b32.png";